
export const CSkeleton = () => {

    return (
        <>
            <div className={` CSkilton`} />
        </>
    )
}

